if (!window.Eurus.loadedScript.has('product-recommendations.js')) {
  window.Eurus.loadedScript.add('product-recommendations.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecommendations', {
        loading: false,
        listOfUpsellProducts: [],
        el: '',
        listUpsellId: [],
        productCount: 0,
        /* ⛔ 12 Sep 2026 — THIS FIRED ONE FULL SECTION FETCH PER PRODUCT IN THE CART.
           listId is every product_id in the cart (see snippets/cart-upsell.liquid),
           and the loop only stopped early once it had collected enough
           recommendations. On a niche wholesale catalogue plenty of products
           return none, so it walked the whole list: a 40 line order opened the
           upsell and sent 40 heavy requests. The bigger the order, the more load,
           which is precisely backwards for a wholesaler whose best customers place
           the biggest orders.

           Worse, the try/catch sat INSIDE the loop, so a shop that was refusing
           got all 40 anyway, one after another, each one failing.

           Three cans on it now: at most MAX_REQUESTS go out however large the cart
           is; they are sampled across the cart rather than taken off the front, so
           a big order still gets varied suggestions; and the first refusal ends the
           loop instead of starting a queue of them. */
        async loadUpsell(el, url, listId, limit, maxItems) {
          const MAX_REQUESTS = 4;
          this.el = el;
          this.loading = true;
          this.listOfUpsellProducts = [];
          this.productCount = 0;
          this.listUpsellId = [];

          /* Nothing to suggest is a far smaller loss than a cart that will not load. */
          if (window.NHCart && typeof window.NHCart.cooling === 'function' && window.NHCart.cooling()) { this.loading = false; return; }

          let picks = listId || [];
          if (picks.length > MAX_REQUESTS) {
            const step = picks.length / MAX_REQUESTS;
            const spread = [];
            for (let k = 0; k < MAX_REQUESTS; k++) spread.push(picks[Math.floor(k * step)]);
            picks = spread;
          }

          for (let i = 0; i < picks.length; i++) {
            if (this.productCount >= maxItems) {
              break;
            }
            try {
              const response = await fetch(`${url}&product_id=${picks[i]}&limit=${limit}&intent=related`);
              if (!response.ok) break;   /* refused or errored: stop, do not queue up more */
              const text = await response.text();
              const html = document.createElement('div');
              html.innerHTML = text;
              const des = document.querySelector('.cart-upsell-carousel');
              const src = html.querySelector('.cart-upsell-carousel')
              if(src && des) des.innerHTML = src.innerHTML
              const recommendations = html.querySelector('.product-recommendations');
      
              if (recommendations && recommendations.innerHTML.trim().length) {
                const newUpsellProducts = recommendations.querySelectorAll('template[x-teleport="#cart-upsell-drawer"], template[x-teleport="#cart-upsell"]');
                this.listOfUpsellProducts = [...newUpsellProducts, ...this.listOfUpsellProducts];
      
                for (let index = 0; index < this.listOfUpsellProducts.length; index++) {
                  if (this.productCount >= maxItems) {
                    break;
                  }
                  
                  const element = this.listOfUpsellProducts[index];
                  const elementId = new DOMParser().parseFromString(element.innerHTML, 'text/html').querySelector('.hover-text-link, .link-product-variant').id;
                  
                  if (!this.listUpsellId.includes(elementId)) {
                    this.listUpsellId.push(elementId);
                    el.appendChild(element);
                    this.productCount++;
                  }
                }
      
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0';
                }
              } else if (recommendations && recommendations.classList.contains('main-product')) {
                recommendations.classList.add("hidden");
                el.innerHTML = recommendations.innerHTML;
              }
            } catch (e) {
              /* a dropped connection mid list: stop rather than work through the rest */
              this.loading = false;
              break;
            } finally {
              this.loading = false;
            }
          }
        },
        load(el, url) {
          this.loading = true;
          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                requestAnimationFrame(() => {
                  el.innerHTML = recommendations.innerHTML;
                });
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0';
                }
              } else if (recommendations.classList.contains('main-product')) {
                recommendations.classList.add("hidden");
                el.innerHTML = recommendations.innerHTML;
              }
            })
            .finally(() => {
              this.loading = false;
            }) 
            .catch(e => {
              console.error(e);
            });
        }
      });      
    });
  });
}